export const SALES_INFO_QUERIES = {
  GET_GOLD_SOLD_BUY_ORDER: `
          query GetGoldenTBuyOrder($input: OderTempDataInput!){
              getGoldenBuyOrder(input: $input){
                  totalPrice
                  totalUnitPrice
                  totalProcessPrice
                  processPriceSap
                  totalPriceSap
                  totalItemWeightOfStool
                  totalItemWeightSeed
                  totalHao
                  totalGoldenWeightThread
                  totalGoldWeightOfStool
                  totalQ10
                  totalQuantity
                  finalPrice
                  finalPriceSap
                  totalGoldPrice
                  tcustomer{
                      id
                      storeName
                  }
                  tdealPrice{
                      salePrice
                      dealPrice
                      statusId
                      statusName
                  }
                  orderTempDetail{
                      id
                      haolaiCost
                      totalPrice
                      totalPriceSap
                      goldPrice
                      unitPrice
                      itemCode
                      tproduct{
                          id
                          name
                          age
                          urlImage1
                          textScan
                          ttype{
                              id
                              name
                          }
                      }
                      tstorageLocation{
                          batch
                          sloc
                          q10
                      }
                      processPrice
                      processPriceSap
                      finalPrice
                      finalPriceSap
                      itemWeightSeed
                      goldWeightThread
                      goldWeightOfStool
                      quantity
                      unitPrice
                      createDate
                      modifyDate
                      tmodifyUser{
                          id
                          fullName
                      }
                      checkInventory
                      voucherName
                  }
                  goldenTBuy{
                      sloc
                      age
                      goldenWeightThread
                      goldWeightOfStool
                      hao
                      itemWeightOfStool
                      itemWeightSeed
                      q10
                      quantity
                  }
              }
          }
      `,
  GET_CUSTOMER: `
          query GetCustomer($input: TcustomerWhereInput, $skip: Float, $take: Float) {
              getCustomer(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
                  pageInfo {
                  currentPage
                  hasNextPage
                  hasPreviousPage
                  itemsPerPage
                  totalItems
                  totalPages
                  }
                  items {
                  id
                  storeName
                  phone
                  name
                  rankId
                  urlImage1
                  urlImage2
                  urlImage3
                  urlImage4
                  urlImage5
                  trank {
                      id
                      name
                  }
                  taxId
                  address
                  cityId
                  branchId
                  typeSap
                  dayofbirth
                  districtId
                  email
                  gender
                  latitude
                  longitude
                  mainCustomerId
                  cccd
                  tcheckInOuts{
                      id
                      checkInTime
                      checkOutTime
                  }
                  sapCustomerId
                  createDate
                  mainCustomer {
                      id
                      phone
                      address
                      dayofbirth
                      email
                      gender
                      latitude
                      longitude
                      trank {
                      id
                      name
                      }
                  }
                  status
                  wardId
                  terrorismType
                  terrorismUserApproval
                  terrorismUserDate
                  }
              }
          }
      `,
  GET_ORDER: `
      query GetAllOrder($input: OrderDataInput
          $skip: Float
          $take: Float){
              getOrderData(where:$input, skip: $skip, take: $take){
                  pageInfo {
              currentPage
              hasNextPage
              hasPreviousPage
              itemsPerPage
              totalItems
              totalPages
              }
                  items{
                      id
                      useYn
                      plantId
                      isSyncFromSap
                      customerId
                      mainOrderId
                      childCustomerId
                      mainOrderId
                      paymentTypeId
                      createDate
                      modifyDate
                      typeDebt
                      merginPrice
                      merginRate
                      totalPrice
                      totalDiscount
                      totalProcessPrice
                      totalProductPrice
                      totalQ10
                      marketGoldPrice
                      orderTypeId
                      marketNote
                      confMarketTime
                      totalGoldPrice
                      processId
                      orderCheckSyn
                      orderStatusSyn
                      statusId 
                      createName
                      createId
                      modifyName
                      tOrderSeparation {
                          id
                          statusId
                          orderTypeId
                          finalPrice
                          finalPriceSap
                      }
                  }
              }
          }
      `,
  GET_ALL_CONDITION_TYPES: `
          query GetAllConditionType ($input: TconditionTypeWhereInput, $skip:Float, $take: Float) {
              getConditionType (where: $input, skip:$skip, take: $take) {
                  pageInfo {
                  currentPage
                  hasNextPage
                  hasPreviousPage
                  itemsPerPage
                  totalItems
                  totalPages
              }
              items {
                  id
                  name
                  tsGold
                  tsItaly
                  value
              }
              }
          }
      `,
  GET_SAP_ORDER_PROCESS: `
      query GetOrderProcess($input:TorderProcessWhereInput!,$skip:Float,$take:Float){
          getOrderProcess(where:$input,skip:$skip,take:$take){
              pageInfo{
                  currentPage
                  hasNextPage
                  hasPreviousPage
                  itemsPerPage
                  totalItems
                  totalPages
              }
              items{
                  id
                  errorMessage
                  status
                  url
                  orderId
                  torder{
                      tcustomer{
                          mainCustomerId
                      }
                  }
                  status
                  processId
                  processStatus{
                      id
                      name
                      value
                  }
                  createDate
                  createId
                  tcreateUser{
                      fullName
                  }
                  modifyId
                  modifyDate
                  tmodifyUser{
                      fullName
                  }
              }
          }
      }
      `,
  GET_CUSTOMER_LIST: `
      query GetCUstomerList($input:GetCustomerList!){
          getCustomerList(input:$input){
              items{
                  id
              storeName
              phone
              rankId
              urlImage1
              urlImage2
              urlImage3
              urlImage4
              urlImage5
              trank {
                  id
                  name
              }
              taxId
              address
              cityId
              branchId
              dayofbirth
              districtId
              email
              gender
              typeSap
              latitude
              longitude
              mainCustomerId
              cccd
              sapCustomerId
              createDate
              mainCustomer {
                  id
                  name
                  phone
                  address
                  dayofbirth
                  email
                  gender
                  latitude
                  longitude
                  trank {
                  id
                  name
                  }
              }
              status
              wardId
              }
          }
      }
      `,
  UPDATE_ORDER_TEMP: `
        mutation UpdateOrderTemp($input:TorderTempInput!){
          updateOrderTemp(input:$input){
              id
              customerId
              childCustomerId
              totalProcessPrice
              totalQ10
              totalGoldPrice
              totalProductPrice
              totalDiscount
              totalPrice
              merginPrice
              merginRate
              statusId
          }
      }
      `,
  GET_ORDER_TEMP: `
      query GetOrderTempById($input: OrderNotMainOrderInput
        $skip: Float
        $take: Float){
            getOrderNotMainOrderWeb(where:$input, skip: $skip, take: $take){
                pageInfo {
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
            }
                items{
                    id
                    useYn
                    mainOrderId
                    statusId
                    teamSalesId
                    tteamSale{
                        subId
                        teamType
                    }
                    plantId
                    customerId
                    createDate
                    createId
                    customerId
                    modifyDate
                    processPriceBfDiscount
                    modifyId
                    totalPrice
                    finalPrice
                    orderTypeId
                    torderType{
                        id
                        name
                    }
                    tstatus{
                        id
                        name
                    }
                }
            }
        }
      `,
  GET_ORDER_DEAL_PRICE: `
      query GetOrderDealPrice($input:GetApprovalDataInput!){
        getOrderApprovalData(where:$input){
            dealPrice
            salePrice
            statusId
            status
            usePolicyPrice
            note
            createName
            createDate
            approvalDetail{
                createId
                tcreateUser{
                    fullName
                }
                createDate
            }
            }
        }
      `,
  GET_GOLD_SOLD_Y_BY_ORDER: `
      query GetGoldenYBuyOrder($input: OderTempDataInput!){
          getGoldenBuyOrder(input: $input){
              totalGoldenWeightThread
              totalItemWeightThread
              totalValue
              totalItemWeightGram
              totalQuantity
              finalPrice
              totalDiscountAmount
              totalGoldWeightOfStool
              totalItemWeightOfStool
              finalPriceSap
              totalProcessPrice
              totalAmountGram
              goldenYBuy{
                  groupPrice
                  sloc
                  age
                  goldenWeightThread
                  goldWeightOfStool
                  quantity
                  itemWeightSeed
                  itemWeightGram
                  itemWeightThread
                  itemWeightOfStool
                  value
                  intGroupPrice
              }
              orderTempDetail{
                  id
                  itemCode
                  totalPrice
                  haolaiCost
                  amountGram
                  groupPrice
                  intGroupPrice
                  unitPriceByGram
                  unitPriceByThread
                  processPrice
                  tproduct{
                      id
                      name
                      age
                      urlImage1
                      textScan
                      ttype{
                          id
                          name
                      }
                  }
                  tcreateUser{
                      fullName
                  }
                  tmodifyUser{
                      fullName
                  }
                  createDate
                  modifyDate
                  goldWeightThread
                  goldWeightOfStool
                  finalPrice
                  quantity
                  tstorageLocation{
                  itemWeightThread
                  itemWeightOfStool
                  batch
                  sloc
                  }
                  itemWeightGram
                  unitPriceByGram
                  discountAmount
                  finalPriceSap
                  checkInventory
                  voucherName
              }
          }
      }
      `,
  GET_ORDER_STATUS_COMBOBOX: `
          query GetOrderStatusComboBox($input:TcodeWhereInput){
              getCode(where:$input){
                  items{
                      id
                      name
                  }
              }
          }
      `,
  CREATE_DEAL_PRICE: `
    mutation CreateDealPrice($input:DealPriceInput!){
        createDealPrices(input:$input){
            id
            orderId
            salePrice
            usePolicyPrice
        }
    }
      `,
};
